export const tr = {
    'client-features': 'Client features',
    'operator-features': 'Operator features'
};
